import styled from "styled-components";
import cssVars from "../../styles/cssVariables.vars";

export const StyledFinishAttendance = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 0.25rem;
    background-color: ${cssVars.colorGrey[8]};
    width: 30rem;
    height: max-content;
    box-sizing: border-box;

    >header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >h2 {
            font-size: 1rem;
            font-weight: 500;
        }

        >svg{
            font-size: 1.5rem;
            cursor: pointer;

            :hover {
                transform: scale(1.25);
            }
        }
    }

    >button {
        font-size: 1rem;
        padding: 0.625rem 2rem;
        margin-top: 0.5rem;
    }
`;